import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Tab, Nav } from 'react-bootstrap';
import Layout from '~/Components/Layout/Layout';
import AnimateHeight from 'react-animate-height';
import classnames from 'classnames';

import './experiance.scss'

import { CalendarIcon, HospitalityIcon, ChevronDown, LocationIcon, PersonalIdIcon, ProfileIcon, RaceTicketsIcon } from '../../Components/Icons/Icons';
import ScheduleCard from '../../Components/ScheduleCard/ScheduleCard';
import RaceDayTickets from './RaceDayTickets';
import TracksideExperiances from './TracksideExperieances';
import TracksideHospitality from './TracksideHospitality';
import Moment from "react-moment";
import placeholder from "~/assets/placeholder-image.svg";
import {groupBy} from "~/services/helpers";
import monent from "moment";
import EventTextShow from "~/Components/EventTextShow";
import RegisterShortcut from '../../Components/RegisterShortcut/RegisterShortcut';
import Translate from "~/Components/ContentTranslate/Translate";
import TextTranslate from '../../Components/TextTranslate/TextTranslate';

const Experiance = ({currentLanguage, ...props}) => {
    if (!props.invitation) {
        return <></>;
    }

    const [schedulesExpanded, setSchedulesExpanded] = useState(false);
    const event = props.invitation.event;
    const showSchedule = event.schedule_status;
    const pkg = props.invitation.package;

    const schedulesGrouped = groupBy(event.schedules, 'date');

    return (
        <Layout colorBg page="experiance">
            <div className="container">
                <div className="introduction text-center mb-4">
                    <h1>
                        <TextTranslate name="experiance-welcome" fallback="Welcome to the" textOnly/>
                        <span>&nbsp;</span><Translate model={event} field="name" />
                    </h1>
                    <p><Translate model={event} field="welcome_message" /></p>
                </div>

                <section className="overview text-center">
                    <div className="key-details">
                        <div className="key-details__item">
                            <div className="desc">
                                <ProfileIcon />
                                <h4><TextTranslate name="event-partner" fallback="Event Partner"/></h4>
                            </div>
                            <p><Translate model={event} field="partner" /></p>
                        </div>
                        <div className="key-details__item">
                            <div className="desc">
                                <LocationIcon />
                                <h4><TextTranslate name="event-location" fallback="Event Location"/></h4>
                            </div>
                            <p><Translate model={event} field="location" /></p>
                        </div>
                        <div className="key-details__item">
                            <div className="desc">
                                <CalendarIcon />
                                <h4><TextTranslate name="event-date" fallback="Event Date" /></h4>
                            </div>
                            <p><Moment locale={currentLanguage?.code || 'en'} format="DD/MM/YYYY">{event.start}</Moment> - <Moment locale={currentLanguage?.code || 'en'} format="DD/MM/YYYY">{event.end}</Moment></p>
                        </div>
                    </div>

                    <div className="event-overview row flex-xl-row flex-column-reverse text-left">
                        <div className="event-overview-main col-xl-6 col-12">
                            <h4><TextTranslate name="event-overview" fallback="Event Overview"/></h4>
                            <p className="pre-line"><Translate model={event} field="overview" /></p>
                            <span className="text-caption text-uppercase"><TextTranslate name="event-race-address" fallback="Race address"/></span>
                            <p className="pre-line"><Translate model={event} field="address" /></p>
                            <a href={event.address_link} target="_blank" className="link text-primary"><TextTranslate name="word-show-map" fallback="Show map"/></a>
                        </div>
                        <div className="image col-xl-6 col-12 pr-xl-0 pr-0 pl-0 pl-xl-2 mt-xl-0 mb-3">
                            <div style={{backgroundImage: `url(${event.overview_image?.download_url || placeholder})`}}></div>
                        </div>
                    </div>
                </section>
            </div>

            {showSchedule ?
            <section className="schedule">
                <div className="container p-0">
                    <div className="row no-gutters">
                        <div className="headline text-center w-100">
                            <h3><TextTranslate name="event-schedule" fallback="Event Schedule"/></h3>
                            <p className="col-12 no-gutters-col mb-0">
                                <EventTextShow
                                    defaultValue="Edit this text on CMS"
                                    event={props.invitation.event}
                                    name={'schedule-head-title'} />
                            </p>
                        </div>

                        <AnimateHeight
                            className="schedules-anim"
                            duration={ 250 }
                            height={ schedulesExpanded ? 'auto' : 740 }
                        >
                            <div
                                className={classnames([
                                    "schedules",
                                    { expanded: schedulesExpanded }
                                ])}
                            >
                                {Object.keys(schedulesGrouped).map((date, key) => (
                                    <div key={key} className="schedules-folder">
                                        <div className="date-title">
                                            <div className="date">
                                                <Moment locale={currentLanguage?.code || 'en'} format="dddd, MMMM DD, YYYY" date={date} />
                                            </div>
                                            <div className="d-block pre-line event-description">
                                                <EventTextShow
                                                    classes="text-subhead"
                                                    event={props.invitation.event}
                                                    name={'schedule-' + monent(date).locale('en').format('DD/MM/YYYY')} />
                                            </div>
                                        </div>

                                        {schedulesGrouped[date].map(schedule => <ScheduleCard key={schedule.id} schedule={schedule} lang={currentLanguage} />)}
                                    </div>
                                ))}

                                <div
                                    className="expand"
                                    onClick={() => setSchedulesExpanded(!schedulesExpanded)}
                                >
                                    <div className="d-inline-flex align-items-center">
                                        <p className="mr-2">
                                            { schedulesExpanded ? <TextTranslate name="schedule-collapse" fallback='Click to collapse'/> : <TextTranslate name="schedule-expand" fallback="Click to expand"/> }
                                        </p>
                                        <div className="wicon">
                                            <ChevronDown />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </AnimateHeight>
                    </div>
                </div>
            </section> : null}

            <section
                className={classnames([
                    'yourexperience text-center',
                    {"schedule-shown": !showSchedule}
                ])}
            >
                <div className="headline">
                    <h3><TextTranslate name="experience-your-experience" fallback="Your Experience"/></h3>
                    <p><TextTranslate name="experience-your-experience-desc"
                        fallback="Formula 1 brings you to the heart of the most iconic city
                        centres, where you will witness first-hand the exciting and unpredictable wheel to wheel combat
                        of electric street racing. The following provides a detailed overview of the experience offered by
                        the Mercedes-Benz EQ Formula 1 Team."/></p>
                </div>

                <div className="experience-view">
                    <Tab.Container defaultActiveKey="racedaytickets">
                        <Nav className="experience-view__nav">
                            <div className="d-flex">
                            <Nav.Item>
                                <Nav.Link eventKey="racedaytickets">
                                    <RaceTicketsIcon/>
                                    <p><TextTranslate name="event-racedaytickets" fallbakc="Race Day Tickets"/></p>
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey="tsexperiences">
                                    <PersonalIdIcon/>
                                    <p><TextTranslate name="event-trackside-experiences" fallback="Trackside Experiences"/></p>
                                </Nav.Link>
                            </Nav.Item>
                            {pkg.hospitality && pkg.hospitalities.length > 0 && (
                                <Nav.Item>
                                    <Nav.Link eventKey="tshospitality">
                                        <HospitalityIcon/>
                                        <p><TextTranslate name="event-trackside-hospitality" fallback="Trackside Hospitality"/></p>
                                    </Nav.Link>
                                </Nav.Item>
                            )}
                            </div>
                        </Nav>

                        <Tab.Content className="w-100">
                            <Tab.Pane className="experience-view__view" eventKey="racedaytickets">
                                <RaceDayTickets data={event.race_day_tickets} />
                            </Tab.Pane>
                            <Tab.Pane className="experience-view__view" eventKey="tsexperiences">
                                <TracksideExperiances data={event.trackside_experiences} />
                            </Tab.Pane>
                            {pkg.hospitality && pkg.hospitalities.length > 0 && (
                                <Tab.Pane className="experience-view__view" eventKey="tshospitality">
                                    <TracksideHospitality data={pkg.hospitalities} />
                                </Tab.Pane>
                            )}
                        </Tab.Content>
                    </Tab.Container>

                    <div className="text-left text-lg-center text-note px-3">
                        <p className="mb-0"><TextTranslate name="hospitality-note-msg" fallback="Please take note of your hospitality inclusions above and note inclusions will vary based on your type of experience (as indicated in your invitation) and offered at your specific race weekend."/></p>
                    </div>
                </div>
            </section>

            <RegisterShortcut />
        </Layout>
    );
}

const mapStateToProps = (state) => ({
    currentLanguage: state.translations?.currentLanguage,
    auth: state.auth.auth,
    invitation: state.invitation.data
});

export default connect(mapStateToProps)(Experiance);
